import React from "react";

import { connect } from "react-redux";

import Stack from "@busbud/design-system-components/dist/Stack";
import Text from "@busbud/design-system-components/dist/Text";

import type { ErrorModalButtonType } from "@app/helpers/api-error";
import { useAppContext } from "@app/helpers/hooks";
import type { ResultsReduxState } from "@app/types/results-redux-types";
import type { SearchInfo } from "@app/types/search-types";

import * as ErrorTracking from "../../../tracking/error-tracking";
import { AlertDialog } from "../../alert-dialog";
import { BusAgnosticIllustration } from "../illustrations/busAgnostic";
import { reloadOutboundPage } from "../utils/reload-outbound-page";

interface OwnProps {}

interface ReduxProps {
  search: SearchInfo;
}

const TTLWarning: React.FC<OwnProps & ReduxProps> = ({ search }) => {
  const { tracker, translator, urlBuilder } = useAppContext();

  const message = (
    <Stack direction="column" alignItems="center" spacing={1}>
      <div>
        <BusAgnosticIllustration />
      </div>
      <Text size="lg" align="center">
        {translator.t("!results.expiry-popup.title")}
      </Text>
      <Text size="md" align="center">
        {translator.t("!results.expiry-popup.message")}
      </Text>
    </Stack>
  );

  const primary_button = {
    label: translator.t("!results.expiry-popup.cta")
  };

  const onAction = (button_type: ErrorModalButtonType) => {
    tracker.track(ErrorTracking.clickedErrorButton(button_type));

    reloadOutboundPage(urlBuilder, search);
  };

  return (
    <AlertDialog
      title={false}
      message={message}
      actionHandler={onAction}
      primary_button={primary_button}
    />
  );
};

const mapStateToProps = (state: ResultsReduxState): any => {
  return {
    search: state.search
  };
};

const TTLWarningComponent = connect<
  ReduxProps,
  {},
  OwnProps,
  ResultsReduxState
>(mapStateToProps)(TTLWarning);

export { TTLWarningComponent as TTLWarning };
